import axios from "../../utils/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  managers: [],
};

const managersSlice = createSlice({
  name: "managers",
  initialState,
  reducers: {
    setManagers(state, action) {
      state.managers = action.payload;
    },
    clearManagers(state, action) {
      state.managers = [];
    },
    updateManager(state, action) {
      const { id, managerDetails } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return managerDetails;
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updateFullName(state, action) {
      const { id, fullName } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            fullName: fullName,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updateAddress(state, action) {
      const { id, address } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            address: address,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updateCity(state, action) {
      const { id, city } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            city: city,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updateCountry(state, action) {
      const { id, country } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            country: country,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updatePostcode(state, action) {
      const { id, postcode } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            postcode: postcode,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updateTelephone(state, action) {
      const { id, telephone } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            telephone: telephone,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updateMobile(state, action) {
      const { id, mobile } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            mobileNumber: mobile,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updateEmail(state, action) {
      const { id, email } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            email: email,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updateOccupation(state, action) {
      const { id, occupation } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            occupation: occupation,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updateCompany(state, action) {
      const { id, company } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            company: company,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updateTIN(state, action) {
      const { id, tin } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            tinNumber: tin,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updateOffers(state, action) {
      const { id, offers } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            offers: offers,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updateFavicon(state, action) {
      const { id, favicon } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            favicon: favicon,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updatePrivilege(state, action) {
      const { id, privilege } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            privilege: privilege,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updateWhitelabel(state, action) {
      const { id, whitelabelImage } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            whitelabelImage: whitelabelImage,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updateBackgroundColor(state, action) {
      const { id, color } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            backgroundColor: color,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updateFontColor(state, action) {
      const { id, color } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            fontColor: color,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },
    updateSidebarPosition(state, action) {
      const { id, position } = action.payload;
      const updatedManagers = state.managers.map((manager) => {
        if (manager.id === id) {
          return {
            ...manager,
            sidebarPosition: position,
          };
        }
        return manager;
      });
      return {
        ...state,
        managers: updatedManagers,
      };
    },

    addManager: (state, action) => {
      const newManager = action.payload;
      return {
        ...state,
        managers: [...state.managers, newManager],
      };
    },
    removeManager: (state, action) => {
      const idToRemove = action.payload;
      const newManagers = state.managers.filter(
        (manager) => manager.id !== idToRemove
      );
      return {
        ...state,
        managers: newManagers,
      };
    },
  },
});

export const clearAllManagers = () => (dispatch) => {
  dispatch(managersSlice.actions.clearManagers());
};

export function getManagers() {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/managers`,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(managersSlice.actions.setManagers(response.data.data));
      return Promise.resolve(response.data.message);
    } catch (error) {
      dispatch(managersSlice.actions.setManagers([]));
      return Promise.reject(error.message);
    }
  };
}

export function updateManagerDetails({ id, values }) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/managers/${id}`,
        values,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(
        managersSlice.actions.updateManager({
          id: id,
          managerDetails: response.data.data,
        })
      );
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export function deleteManager(id) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/managers/${id}`,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(managersSlice.actions.removeManager(id));
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export function updateManagerName(id, fullName) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("fullName", fullName);
    try {
      await axios.put(
        `process.env.REACT_APP_POS2CLOUD_BACKEND_URL/systemusers/` +
          id +
          "/update/fullName",
        formData,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      dispatch(managersSlice.actions.updateFullName({ id, fullName }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerAddress(id, address) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("address", address);
    try {
      await axios.put(
        `process.env.REACT_APP_POS2CLOUD_BACKEND_URL/systemusers/` +
          id +
          "/update/address",
        formData,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      dispatch(managersSlice.actions.updateAddress({ id, address }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerCity(id, city) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("city", city);
    try {
      await axios.put(
        `process.env.REACT_APP_POS2CLOUD_BACKEND_URL/systemusers/` +
          id +
          "/update/city",
        formData,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      dispatch(managersSlice.actions.updateCity({ id, city }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerCountry(id, country) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("country", country);
    try {
      await axios.put(
        `process.env.REACT_APP_POS2CLOUD_BACKEND_URL/systemusers/` +
          id +
          "/update/country",
        formData,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      dispatch(managersSlice.actions.updateCountry({ id, country }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerPostcode(id, postcode) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("postcode", postcode);
    try {
      await axios.put(
        `process.env.REACT_APP_POS2CLOUD_BACKEND_URL/systemusers/` +
          id +
          "/update/postcode",
        formData,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      dispatch(managersSlice.actions.updatePostcode({ id, postcode }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerTelephone(id, telephone) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("telephone", telephone);
    try {
      await axios.put(
        `process.env.REACT_APP_POS2CLOUD_BACKEND_URL/systemusers/` +
          id +
          "/update/telephone",
        formData,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      dispatch(managersSlice.actions.updateTelephone({ id, telephone }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerMobile(id, mobile) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("mobile", mobile);
    try {
      await axios.put(
        `process.env.REACT_APP_POS2CLOUD_BACKEND_URL/systemusers/` +
          id +
          "/update/mobile",
        formData,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      dispatch(managersSlice.actions.updateMobile({ id, mobile }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerEmail(id, email) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("email", email);
    try {
      await axios.put(
        `process.env.REACT_APP_POS2CLOUD_BACKEND_URL/systemusers/` +
          id +
          "/update/email",
        formData,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      dispatch(managersSlice.actions.updateEmail({ id, email }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerOccupation(id, occupation) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("occupation", occupation);
    try {
      await axios.put(
        `process.env.REACT_APP_POS2CLOUD_BACKEND_URL/systemusers/` +
          id +
          "/update/occupation",
        formData,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      dispatch(managersSlice.actions.updateOccupation({ id, occupation }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerCompany(id, company) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("company", company);
    try {
      await axios.put(
        `process.env.REACT_APP_POS2CLOUD_BACKEND_URL/systemusers/` +
          id +
          "/update/company",
        formData,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      dispatch(managersSlice.actions.updateCompany({ id, company }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerTIN(id, tin) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("tin", tin);
    try {
      await axios.put(
        `process.env.REACT_APP_POS2CLOUD_BACKEND_URL/systemusers/` +
          id +
          "/update/tin",
        formData,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      dispatch(managersSlice.actions.updateTIN({ id, tin }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerOffers(id, offers) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("offers", offers);
    try {
      await axios.put(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/managers/${id}/update/offers`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      dispatch(managersSlice.actions.updateOffers({ id, offers }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerFavicon(id, favicon) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("favicon", favicon);
    try {
      await axios.put(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/systemusers/${id}/update/favicon`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      dispatch(managersSlice.actions.updateFavicon({ id, favicon }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerWhitelabel(id, whitelabel) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("whitelabel", whitelabel);
    try {
      await axios.put(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/systemusers/${id}/update/whitelabel`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      dispatch(managersSlice.actions.updateWhitelabel({ id, whitelabel }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerBackgroundColor(id, color) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("backgroundColor", color);
    try {
      await axios.put(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/systemusers/${id}/update/backgroundColor`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      dispatch(managersSlice.actions.updateBackgroundColor({ id, color }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerFontColor(id, color) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("fontColor", color);
    try {
      await axios.put(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/systemusers/${id}/update/fontColor`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      dispatch(managersSlice.actions.updateFontColor({ id, color }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerSidebarPosition(id, position) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("sidebarPosition", position);
    try {
      await axios.put(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/systemusers/${id}/update/sidebarPosition`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      dispatch(managersSlice.actions.updateSidebarPosition({ id, position }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function updateManagerPrivilege(
  userId,
  clientId,
  privilege,
  upperEntityId
) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const formData = new FormData();
    formData.append("entityId", clientId);
    formData.append("privilege", privilege);
    if (privilege !== "ADMIN" && privilege !== "VIEWER") {
      formData.append("upperEntityId", upperEntityId);
    } else {
      formData.append("upperEntityId", -1);
    }

    try {
      await axios.put(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/systemusers/` +
          userId +
          "/update/privilege",
        formData,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      dispatch(managersSlice.actions.updatePrivilege({ clientId, privilege }));
      return Promise.resolve("Success");
    } catch (error) {
      return Promise.reject("Error");
    }
  };
}

export function addNewManager({ values }) {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const data = {
        fullName: values.fullName,
        address: values.address,
        city: values.city,
        country: values.country,
        postcode: values.postcode,
        telephoneNumber: values.telephoneNumber,
        mobileNumber: values.mobileNumber,
        email: values.email,
        occupation: values.occupation,
        company: values.company,
        tin: values.tin,
        username: values.username,
        currency: values.currency,
        preferredLanguage: values.preferredLanguage,
        billingEmail: values.billingEmail,
        sendWelcomeMail: values.sendWelcomeMail,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/managers`,
        data,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(managersSlice.actions.addManager(response.data.data));
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export function removeExistingManager(id) {
  return (dispatch) => {
    dispatch(managersSlice.actions.removeManager(id));
  };
}

export const {
  setManagers,
  clearManagers,
  updateFullName,
  updateAddress,
  updateCity,
  updateCountry,
  updatePostcode,
  updateTelephone,
  updateEmail,
  updateOccupation,
  updateCompany,
  updateTIN,
  updateOffers,
  updatePrivilege,
  addManager,
  removeManager,
  updateFavicon,
  updateWhitelabel,
  updateBackgroundColor,
  updateFontColor,
  updateSidebarPosition,
  updateManager,
} = managersSlice.actions;
export default managersSlice.reducer;
